<template>
  <span>
    <swiper
      ref="mySwiper"
      :options="swiperOptions"
      class="nomobile"
      :slides-per-view="3"
      :space-between="50"
    >
      <swiper-slide>
        <a href="/release/an-eye-into-unspeakableness" class="slide-container shade2">
          <div class="vid-embed">
            <div class="slide-content">
              <h1>Silver Motion Picture Zenit - An Eye Into Unspeakableness!<br /></h1>
              <router-link to="/release/an-eye-into-unspeakableness" class="button"
                >BUY NOW!</router-link
              >
            </div>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/oDMBgeZJMPk?autoplay=1&loop=1&mute=1&showinfo=0&controls=0&playlist=oDMBgeZJMPk&vq=hd720"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="/release/array" class="slide-container shade2">
          <div class="vid-embed">
            <div class="slide-content">
              <h1>Kalaedo - Array!<br /></h1>
              <router-link to="/release/array" class="button"
                >BUY NOW!</router-link
              >
            </div>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/G5PRQDCbE_8?autoplay=1&loop=1&mute=1&showinfo=0&controls=0&playlist=G5PRQDCbE_8&vq=hd720"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="/release/obliviate-1" class="slide-container shade2">
          <div class="vid-embed">
            <div class="slide-content">
              <h1>OBLIVIATE<br /></h1>
              <router-link to="/release/obliviate-1" class="button"
                >BUY NOW!</router-link
              >
            </div>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Cof8ilUj4Jc?autoplay=1&loop=1&mute=1&showinfo=0&controls=0&playlist=Cof8ilUj4Jc&vq=hd720"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-container shade2">
          <div class="vid-embed">
            <div class="slide-content">
              <h1>CAN YOU WAIT FOR THE NEXT ONE?<br /></h1>
            </div>
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/0tfzqFruwMw?autoplay=1&loop=1&mute=1&showinfo=0&controls=0&playlist=0tfzqFruwMw"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <swiper ref="mySwiper" :options="swiperOptions" class="mobile">
      <swiper-slide>
        <a href="/release/an-eye-into-unspeakableness" class="slide-container shade2">
          <div class="vid-embed"
            style="
              background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1653408465/final_cover_9e3c8ff758.png);
            "          >
            <div class="slide-content">
              <router-link to="/release/an-eye-into-unspeakableness" class="button"
                >BUY NOW!</router-link
              >
            </div>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="release/array" class="slide-container shade2">
          <div class="vid-embed"

            style="
              background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1647884649/Array_Artwork_Hi_Res_Square_219b7001f7.jpg);
            "          >
            <div class="slide-content">
              <router-link to="release/array" class="button"
                >BUY NOW!</router-link
              >
            </div>
          </div>
        </a>
      </swiper-slide>
      <swiper-slide>
        <a href="/release/obliviate-1" class="slide-container">
          <div
            class="vid-embed"
            style="
              background-image: url(https://res.cloudinary.com/hyimvofxm/image/upload/v1640732952/ab67616d0000b273b64f3b1617e688486d57110b_0870674c08.jpg);
            "
          >
            <div class="slide-content">
              <router-link to="/release/obliviate-1" class="button"
                >BUY NOW!</router-link
              >
            </div>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <section class="spaced">
      <div class="container content">
        <h1>
          Let us, together, create a future that's worth looking forward to.
        </h1>
        <br />
        <p>
          With our hearts burning for good and deep sound, Patronus Records was
          founded in 2018. Since then, we strive to give talented artists a
          platform as well as shape the next generation of psychedelic
          electronica. Besides Music we offer Events, Event-decoration, Event
          acoustics and Sound-Engineering.
        </p>
      </div>
    </section>
    <section class="spaced artist-background">
      <div class="container content flex">
        <div class="column c6 text-left">
          <h3>LATEST RELEASES</h3>
        </div>
        <div class="colimn c6 text-right">
          <router-link to="music">
            EXPLORE MORE &nbsp;
            <i class="fas fa-play-circle"></i>
          </router-link>
        </div>
      </div>
      <div class="container content text-left">
        <hooper :settings="carouselSettings" style="height: fit-content">
          <slide
            v-for="album in albums.slice(0, 5)"
            :key="album.id"
            style="padding: 5px"
          >
            <router-link
              class="profile card"
              :to="{ name: 'release', params: { id: album.slug } }"
            >
              <div class="card-inner">
                <div class="shade">
                  <div
                    class="artwork"
                    v-if="album.AlbumArtwork !== null"
                    :style="
                      'background-image:url(' + album.AlbumArtwork.url + ')'
                    "
                  ></div>
                  <div class="card-overlay text-left push-middle">
                    <div class="card-content">
                      <i class="fas fa-play-circle player-link"></i>
                      <h2>{{ album.AlbumTitle }}</h2>
                      <h3>
                        {{ album.album_type.Type }} -
                        <span v-for="artist in album.artists" :key="artist.id">
                          {{ artist.name }}
                        </span>
                        {{ album.ArtistOverRide }}
                      </h3>
                    </div>
                  </div>
                  <div class="card-overlay-player text-left push-middle">
                    <div class="card-content">
                      <i class="fas fa-play-circle player-link"></i>
                      <h2>{{ album.AlbumTitle }}</h2>
                      <h3>
                        {{ album.album_type.Type }} -
                        <span v-for="artist in album.artists" :key="artist.id">
                          {{ artist.name }} </span
                        >{{ album.ArtistOverRide }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </slide>
          <hooper-navigation slot="hooper-addons"></hooper-navigation>
          <hooper-pagination
            slot="hooper-addons"
            style="margin-bottom: -20px"
          ></hooper-pagination>
        </hooper>
      </div>
    </section>

    <section class="spaced">
      <div class="container content flex">
        <div class="column c6 text-left">
          <h3>OUR NEW ARITSTS</h3>
        </div>
        <div class="colimn c6 text-right">
          <router-link to="/artists">
            EXPLORE MORE &nbsp;
            <i class="fas fa-play-circle"></i>
          </router-link>
        </div>
      </div>
      <div class="container content text-left">
        <hooper :settings="carouselSettings" style="height: fit-content">
          <slide
            v-for="artist in artisan.slice(0, 5)"
            :key="artist.id"
            style="padding: 5px"
          >
            <router-link
              class="profile card"
              :to="{ name: 'artist', params: { id: artist.slug } }"
            >
              <div class="card-inner">
                <div class="shade">
                  <div
                    class="artwork"
                    :style="
                      'background-image:url(' +
                      artist.profile.url +
                      '); background-size:cover; background-position: center right'
                    "
                  ></div>
                  <div class="card-overlay text-left push-middle">
                    <div class="card-content">
                      <i class="fas fa-play-circle player-link"></i>
                      <h2>{{ artist.name }}</h2>
                      <h3>
                        {{ artist.type }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </slide>
          <hooper-navigation slot="hooper-addons"></hooper-navigation>
          <hooper-pagination
            slot="hooper-addons"
            style="margin-bottom: -20px"
          ></hooper-pagination>
        </hooper>
      </div>
    </section>
  </span>
</template>

<script>
import axios from 'axios'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
  Progress as HooperProgress
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  title: 'Patronus Records',
  name: 'home',
  components: {
    Swiper,
    SwiperSlide,
    axios,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    HooperProgress
  },
  created () {
    axios.get('https://admin.patronusrecords.com/albums').then((response) => {
      response.data.sort(function (a, b) {
        return new Date(b.AlbumRelease) - new Date(a.AlbumRelease)
      })
      this.albums = response.data
    })

    axios.get('https://admin.patronusrecords.com/artists').then((response) => {
      response.data.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at)
      })
      this.artisan = response.data
    })
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted () {
    this.swiper.slideTo(3, 1000, false)
  },
  data () {
    return {
      swiperOptions: {
        initialSlide: 0,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          preventClicks: false,
          preventClicksPropagation: false

        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
        // Some Swiper option/callback...
      },
      albums: [],
      artisan: [],
      hooperSettings: {
        itemsToShow: 1,
        infiniteScroll: true,
        hoverPause: false,
        wheelControl: false
      },
      carouselSettings: {
        infiniteScroll: true,
        hoverPause: false,
        wheelControl: false,
        breakpoints: {
          400: {
            itemsToShow: 1
          },
          600: {
            itemsToShow: 2
          },
          800: {
            itemsToShow: 3
          }
        }
      }
    }
  }
}
</script>

<style>
a {
  cursor: pointer;
}
.slide-layout {
  background-position: center center;
  background-size: cover;
}
.shade {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.shade2 {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
}
.slide-container {
  display: flex;
  flex-direction: column;
  height: 95.6%;
}
.slide-content {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #080c1780;
  max-width: 320px;
  padding: 30px;
  border-radius: 15px;
  z-index: 1000000;
}
.slide-content h1 {
  font-size: 24px;
}
.slide-content .button {
  padding: 10px;
  border: 1px solid var(--primary);
  background-color: var(--primary);
  margin-top: 10px;
  display: block;
  width: fit-content;
  margin: auto;
}
.slide-content:hover .button {
  background-color: white;
  color: var(--primary);
}
.hooper-prev,
.hooper-next {
  fill: white;
}
.hooper-prev .icon,
.hooper-next .icon {
  width: 32px;
  height: 32px;
}
.hooper-prev:hover .icon,
.hooper-next:hover .icon {
  fill: black;
}
.hooper-progress {
  position: absolute;
  bottom: -4px;
  right: 0;
  left: 0;
  height: 4px;
  background-color: #efefef;
}
.card-inner {
  background-size: cover;
}
</style>
<style scoped>
.artwork {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: contain;
}
#myVideo {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  min-width: 100%;
  min-height: 100%;
  overflow: hidden;
}
.vid-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

h1 {
  margin-top: 0px;
}
.vid-embed {
  position: relative;
  z-index: -99;
  width: calc(100% + 0px);
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.swiper-slide {
  position: relative;
  width: 100% !important;
  padding-top: 58.7%;
}

.slide-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.vid-embed {
  width: 100%;
  height: 100%;
}
.swiper-button-next,
.swiper-button-prev {
  color: white;
}
.mobile {
  display: none;
}
.nomobile {
  display: block;
}
.content.flex {
  padding-top: 100px;
  padding-bottom: 0px;
}
.container.content.text-left {
  padding-top: 0px;
  padding-bottom: 100px;
}

.artist-background {
  background: linear-gradient(0deg, rgb(0 0 0 / 50%), rgb(0 0 0 / 30%)),
    url(https://wallpaper-mania.com/wp-content/uploads/2018/09/High_resolution_wallpaper_background_ID_77700431851.jpg);
  background-size: cover;
  box-shadow: inset 0px 0px 20px 0px #000000;
}

@media only screen and (max-width: 660px) {
  .mobile {
    display: block;
    height: 560px !important;
  }
  .mobile .slide-content {
    background: transparent;
  }
  .vid-embed {
    background-size: cover;
    background-position: center center;
  }
  .nomobile {
    display: none;
  }
  .slide-content {
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue